const g_devtricker_indexed_db_prefix = 'devtricker_db_';
const g_devtricker_indexed_db_version = 1;

const g_devtricker_indexed_db_os_name_reading_list = 'reading_list';
const g_devtricker_indexed_db_os_name_like_post = 'liked_posts';
const g_devtricker_indexed_db_os_name_like_comment = 'liked_comments';
const g_devtricker_indexed_db_os_name_following = 'following';
const g_devtricker_indexed_db_os_name_nonce = 'nonces';

class DevTrickerIndexedDBAccess {
    constructor(dbName, version) {
        this.dbName = dbName;
        this.dbVersion = version;
        this.db = null;
    }

    openDB() {
        return new Promise((resolve, reject) => {
            if (this.db) {
                resolve();
                return;
            }

            const request = indexedDB.open(this.dbName, this.dbVersion);

            request.onupgradeneeded = (event) => {
                this.db = event.target.result;

                if (!this.db.objectStoreNames.contains(g_devtricker_indexed_db_os_name_reading_list)) {
                    this.db.createObjectStore(g_devtricker_indexed_db_os_name_reading_list, { keyPath: 'postId' });
                }
                if (!this.db.objectStoreNames.contains(g_devtricker_indexed_db_os_name_like_post)) {
                    this.db.createObjectStore(g_devtricker_indexed_db_os_name_like_post, { keyPath: 'postId' });
                }
                if (!this.db.objectStoreNames.contains(g_devtricker_indexed_db_os_name_like_comment)) {
                    this.db.createObjectStore(g_devtricker_indexed_db_os_name_like_comment, { keyPath: 'commentId' });
                }
                if (!this.db.objectStoreNames.contains(g_devtricker_indexed_db_os_name_following)) {
                    this.db.createObjectStore(g_devtricker_indexed_db_os_name_following, { keyPath: 'userId' });
                }
                if (!this.db.objectStoreNames.contains(g_devtricker_indexed_db_os_name_nonce)) {
                    this.db.createObjectStore(g_devtricker_indexed_db_os_name_nonce, { keyPath: 'nonceId' });
                }
            };

            request.onsuccess = (event) => {
                this.db = event.target.result;
                resolve();
            };

            request.onerror = (event) => {
                reject(event.target.error);
            };
        });
    }

    closeDB() {
        if (this.db) {
            this.db.close();
            this.db = null;
        }
    }

    addData(storeName, data) {
        return new Promise((resolve, reject) => {
            const transaction = this.db.transaction([storeName], 'readwrite');
            const store = transaction.objectStore(storeName);
            const request = store.add(data);

            request.onsuccess = () => resolve();
            request.onerror = (event) => reject(event.target.error);
        });
    }

    getDataByKey(storeName, key) {
        return new Promise((resolve, reject) => {
            const transaction = this.db.transaction([storeName], 'readonly');
            const store = transaction.objectStore(storeName);
            const request = store.get(key);

            request.onsuccess = (event) => resolve(event.target.result);
            request.onerror = (event) => reject(event.target.error);
        });
    }

    updateData(storeName, data) {
        return new Promise((resolve, reject) => {
            const transaction = this.db.transaction([storeName], 'readwrite');
            const store = transaction.objectStore(storeName);

            const request = store.put(data);

            request.onsuccess = () => resolve();
            request.onerror = (event) => reject(event.target.error);
        });
    }

    async deleteData(storeName, key) {
        return new Promise((resolve, reject) => {
            const transaction = this.db.transaction([storeName], 'readwrite');
            const store = transaction.objectStore(storeName);
            const request = store.delete(key);

            request.onsuccess = () => resolve();
            request.onerror = (event) => reject(event.target.error);
        });
    }

    async upsertData(storeName, data) {
        return new Promise((resolve, reject) => {
            const transaction = this.db.transaction([storeName], 'readwrite');
            const store = transaction.objectStore(storeName);
            const request = store.put(data);

            request.onsuccess = () => resolve();
            request.onerror = (event) => reject(event.target.error);
        });
    }

    getAllData(storeName) {
        return new Promise((resolve, reject) => {
            const transaction = this.db.transaction([storeName], 'readonly');
            const store = transaction.objectStore(storeName);
            const request = store.getAll();

            request.onsuccess = (event) => resolve(event.target.result);
            request.onerror = (event) => reject(event.target.error);
        });
    }

    async clearStore(storeName) {
        const transaction = this.db.transaction([storeName], 'readwrite');
        const objectStore = transaction.objectStore(storeName);
        await objectStore.clear();
    }
}